// extracted by mini-css-extract-plugin
module.exports = {"container":"AgencyVideoModal_container__e5x4x","videoWrapper":"AgencyVideoModal_videoWrapper__rwUeB","video":"AgencyVideoModal_video__qTnFZ"};